import { Box, Typography, Container, Divider, SvgIcon } from "@mui/material";
import { Link } from "react-router-dom";
import { KeyboardBackspace } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
// import img54 from "../../assets/newimg/logo.png";
import img54 from "../../assets/ocesha_images/ocesha_logo.png";
import { useState, useEffect } from "react";

import { object, string, TypeOf } from "zod";
import { useSubscribeNewsMutation } from "../../redux/api/authApi";
import { toast } from "react-toastify";
import { useForm, FormProvider, SubmitHandler } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";

const newsSubscribeform = object({
  email: string()
    .min(1, "Email address is required")
    .email("Email address is invalid"),
  status: string(),
});

export type NewsSubscriptionForm = TypeOf<typeof newsSubscribeform>;
const Paymentprocessing = () => {
  const navigate = useNavigate();

  const handleLearnMore = () => {
    navigate("/codegenie/smart_contracts");
  };
  const [subscribeVal, setSubscribeVal] = useState<NewsSubscriptionForm>({
    email: "",
    status: "",
  });
  const [newsSubsctiptionMutation, newsSubscriptionState] =
    useSubscribeNewsMutation();

  const methods = useForm<NewsSubscriptionForm>({
    resolver: zodResolver(newsSubscribeform),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = methods;

  const onSubmitHandler: SubmitHandler<NewsSubscriptionForm> = (values) => {
    newsSubsctiptionMutation(values);
  };

  const handleSubscribeNews = () => {
    newsSubsctiptionMutation(subscribeVal)
      .unwrap()
      .then((response) => {
        console.log("news subscription=>", response);
        const status = response.status;

        console.log(status);
        if (status === "success") {
          toast.success(response.message);
          setSubscribeVal({
            email: "",
            status: "",
          });
        }
      })
      .catch((error) => {
        toast.error(error?.data?.detail ?? "Something went wrong!");
        console.error("Error sending query:", error);
      });
  };
  return (
    <>
      <Container maxWidth="lg">
        <nav className="navbar navbar-expand-md">
          <div className="container-fluid">
            <a className="navbar-brand" href={process.env.REACT_APP_LOGOUT_DOMAIN || "https://ocesha.ai"}>
              {/* <img src="./img/logo.png" alt="" /> */}
              <img src={img54} alt="" style={{ height: "70px" }} />
              {/* <img src={logo} alt="" /> */}
            </a>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarScroll"
              aria-controls="navbarScroll"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="">
                <i className="bi bi-list text-white" />
              </span>
            </button>

            <div className="collapse navbar-collapse" id="navbarScroll">
              <ul className="navbar-nav me-auto my-2 my-lg-0 navbar-nav-scroll gap-4">
                {/* ms-md-5 */}
                <li className="nav-item">
                  <a
                    className="nav-link nav_active"
                    style={{ color: "#4ba5eb", fontWeight: 800 }}
                    href="/"
                  >
                    Home
                  </a>
                </li>

                <li className="nav-item">
                  <a
                    className="nav-link nav_simple"
                    href="https://ocesha-inc.getrewardful.com/signup?_gl=1*1lh53li*_gcl_au*MTc0Njg4MTI3Ni4xNzQ2NzMwMTA0*_ga*MTY2NzI5OTM0OC4xNzQ2NzMwMTA0*_ga_YJYFH7ZS27*czE3NDY3MzAxMDMkbzEkZzEkdDE3NDY3MzEwNjckajM3JGwwJGgw"
                  >
                    Affiliate
                  </a>
                </li>
              </ul>

              <div className="d-flex gap-4" role="search">
                <button
                  className="button_leniar px-3"
                  type="submit"
                  onClick={() => {
                    navigate("/signup");
                  }}
                >
                  Try Now
                </button>
                <button
                  className="btn btn-outline-primary px-3"
                  onClick={() => {
                    navigate("/signin");
                  }}
                >
                  Sign in
                </button>
              </div>
            </div>
          </div>
        </nav>
        <Box py={5}>
          <Typography
            variant="h2"
            color="text.secondary"
            fontWeight={600}
            textAlign="justify"
            mb={10}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              OceSha.ai Payment Processing Addendum
            </div>
          </Typography>
          <Typography>
            Last Updated: March 1, 2026
            <br />
            <br />
            This Payment Processing Addendum (“Payment Addendum”) forms part of the OceSha Terms of Service and governs your use of payment, monetization, and financial transaction features within the Services. <br />
            <br />
            By enabling monetization features or connecting a payment processor, you agree to this Payment Addendum.
          </Typography>
          <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            1. Role of OceSha
          </Typography>
          <Typography>
           OceSha provides infrastructure that enables Creators to:
           <Box component="ul">
              <Box component="li">Sell courses</Box>
              <Box component="li">Accept payments</Box>
              <Box component="li">Receive payouts</Box>
              <Box component="li">Access checkout pages</Box>
              <Box component="li">Integrate third-party payment processors</Box>
            </Box>
            OceSha is not a bank, payment institution, or money transmitter. <br /><br />
            Unless otherwise explicitly stated in writing:
            <Box component="ul">
              <Box component="li">OceSha is not the merchant of record</Box>
              <Box component="li">OceSha does not hold customer funds</Box>
              <Box component="li">OceSha does not process payments directly</Box>
            </Box>
            Payment processing is facilitated through third-party providers.
          </Typography>
          <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
          2. Third-Party Payment Processors
          </Typography>
          <Typography>
           To monetize, you must connect a supported third-party payment processor (e.g., Stripe Connect). <br />br
           By doing so:
           <Box component="ul">
              <Box component="li">You agree to the processor’s terms of service</Box>
              <Box component="li">You authorize OceSha to transmit transaction data as required</Box>
              <Box component="li">You understand OceSha has no control over processor decisions</Box>
            </Box>
            Payment processors may:
            <Box component="ul">
              <Box component="li">Delay payouts</Box>
              <Box component="li">Freeze funds</Box>
              <Box component="li">Terminate accounts</Box>
              <Box component="li">Impose rolling reserves</Box>
            </Box>
            OceSha is not liable for these actions.
          </Typography>
           <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            3. Merchant of Record
          </Typography>
          <Typography>
           Unless OceSha explicitly states otherwise:
           You are the Merchant of Record for all transactions conducted through your courses. <br /><br />
           As Merchant of Record, you are solely responsible for:
           <Box component="ul">
              <Box component="li">Pricing</Box>
              <Box component="li">Refund policies</Box>
              <Box component="li">Customer service</Box>
              <Box component="li">Tax collection and remittance</Box>
              <Box component="li">Chargebacks</Box>
              <Box component="li">Regulatory compliance</Box>
              <Box component="li">Consumer protection compliance</Box>
            </Box>
            OceSha does not assume responsibility for creator-student disputes.
          </Typography>
           <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            4. Fees & Platform Charges
          </Typography>
          <Typography>
           Your subscription plan includes platform access. <br /><br />
            If OceSha introduces:
            <Box component="ul">
              <Box component="li">Transaction fees</Box>
              <Box component="li">Revenue share</Box>
              <Box component="li">Platform service charges</Box>
            </Box>
            They will be clearly disclosed in your dashboard or pricing page. <br /> <br />
            You authorize OceSha to deduct applicable fees from payouts if required.

          </Typography>
           <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
             5. Refunds & Chargebacks
          </Typography>
          <Typography>
           You are solely responsible for:
           <Box component="ul">
              <Box component="li">Setting refund policies</Box>
              <Box component="li">Handling refund requests</Box>
              <Box component="li">Managing chargebacks</Box>
              <Box component="li">Responding to disputes</Box>
            </Box>
            If a chargeback or payment dispute occurs:
            <Box component="ul">
              <Box component="li">The payment processor may debit your connected account</Box>
              <Box component="li">Associated fees may apply</Box>
              <Box component="li">OceSha is not responsible for losses</Box>
            </Box>
            Excessive chargebacks may result in suspension of monetization privileges.
          </Typography>
           <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            6. Taxes
          </Typography>
          <Typography>
           You are solely responsible for:
           <Box component="ul">
              <Box component="li">Determining applicable taxes</Box>
              <Box component="li">Collecting required taxes</Box>
              <Box component="li">Filing and remitting taxes</Box>
              <Box component="li">Issuing invoices or receipts as required</Box>
            </Box>
            OceSha does not provide tax advice.
          </Typography>
           <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            7. Compliance & Restricted Businesses
          </Typography>
          <Typography>
           You may not use OceSha monetization features to sell:
           <Box component="ul">
              <Box component="li">Illegal products</Box>
              <Box component="li">Regulated financial products</Box>
              <Box component="li">Unlicensed medical services</Box>
              <Box component="li">Securities</Box>
              <Box component="li">High-risk financial schemes</Box>
              <Box component="li">Prohibited content under our AI Acceptable Use Policy</Box>
            </Box>
            OceSha reserves the right to disable monetization if regulatory risk is identified.
          </Typography>
           <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            8. Payment Security
          </Typography>
          <Typography>
           OceSha does not store full credit card numbers. <br /><br />
            Payment processing is handled through secure third-party providers that comply with applicable payment security standards (e.g., PCI-DSS). <br /><br />
            You acknowledge that:
            <Box component="ul">
              <Box component="li">No system is fully secure</Box>
              <Box component="li">OceSha is not liable for breaches occurring within third-party processors</Box>
            </Box>
          </Typography>
           <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            9. Payout Timing
          </Typography>
          <Typography>
           Payout timing is determined by:
           <Box component="ul">
              <Box component="li">The payment processor</Box>
              <Box component="li">Risk review policies</Box>
              <Box component="li">Regulatory requirements</Box>
              <Box component="li">Fraud prevention systems</Box>
            </Box>
            OceSha does not guarantee payout speed.
          </Typography>
           <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            10. Limitation of Liability (Financial)
          </Typography>
          <Typography>
           OceSha is not liable for:
           <Box component="ul">
              <Box component="li">Lost revenue</Box>
              <Box component="li">Payment processor errors</Box>
              <Box component="li">Frozen accounts</Box>
              <Box component="li">Tax miscalculations</Box>
              <Box component="li">Currency conversion losses</Box>
              <Box component="li">Fraud by customers</Box>
            </Box>
            Under no circumstances shall OceSha be responsible for financial losses exceeding fees paid to OceSha within the prior 12 months.
          </Typography>
           <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            11. Suspension of Monetization Privileges
          </Typography>
          <Typography>
           OceSha may suspend or revoke monetization access if:
           <Box component="ul">
              <Box component="li">Excessive chargebacks occur</Box>
              <Box component="li">Fraud is suspected</Box>
              <Box component="li">Regulatory violations are identified</Box>
              <Box component="li">AI misuse is linked to paid products</Box>
              <Box component="li">Consumer harm risk is detected</Box>
            </Box>
            We may act without notice if necessary to mitigate risk.
          </Typography>
          <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            12. Updates to Payment Addendum
          </Typography>
          <Typography>
           Because financial regulations evolve, OceSha may update this Payment Addendum. <br /> <br />
           Continued use of monetization features constitutes acceptance.
          </Typography>
           <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            13. Relationship to Terms
          </Typography>
          <Typography>
           This Payment Addendum supplements the OceSha Terms of Service. <br /> <br />
           In the event of conflict, stricter provisions apply.
          </Typography>
          <Link
            to="/signin"
            style={{
              display: "flex",
              marginTop: 40,
              textDecoration: "none",
              color: "white",
            }}
          >
            <SvgIcon sx={{ mr: 1 }}>
              <KeyboardBackspace />
            </SvgIcon>
            Back to log in
          </Link>
        </Box>
      </Container>
    </>
  );
};

export default Paymentprocessing;
